import { isNull, isUndefined } from "lodash";
import { parseString } from "./api";

export const parseCookie = (cookie: string): object => parseString(cookie, "; ");

export const getEventId = (): string | null => getCookie("eventId");
export const setEventId = (id: string | null) => setCookie("eventId", id, id ? 1 : undefined);

export const getReferringUserId = (): number | null => {
  const id = getCookie(REFERRING_USER_ID_NAME);
  return !id || isNaN(+id) || !+id ? null : +id;
};

export const REFERRING_USER_ID_NAME = "rauid";
export const setReferringUserId = (value: number | null | undefined) => {
  setCookie(REFERRING_USER_ID_NAME, isNull(value) || isUndefined(value) ? null : value.toString());
};

const PAYMENT_FAILED_ORDER_ID = "pfoid";
export const getPaymentFailedOrderId = (): string | null => getCookie(PAYMENT_FAILED_ORDER_ID);

export const deletePaymentFailedOrderId = () => deleteCookie(PAYMENT_FAILED_ORDER_ID);

export const setCookie = (cname: string, cvalue: string | null, exdays?: number) => {
  let d = new Date();
  d.setTime(isNull(cvalue) ? -10000 : d.getTime() + (exdays ?? 0) * 24 * 60 * 60 * 1000);

  document.cookie = `${cname}=${cvalue};max-age=${Math.round(d.getTime() / 1000)};path=/`;
};

export const getCookie = (mixed: RegExp | string): string | null => {
  const cookie = parseCookie(document.cookie);
  const key = Object.keys(cookie).find((k) =>
    mixed instanceof RegExp ? k.match(mixed) : k.toLowerCase() === mixed.toLowerCase()
  );
  return key ? cookie[key] : null;
};

export const deleteCookie = (name: string) => {
  setCookie(name, null);
};

export const getCurrentUserId = (): number | null => {
  const v = getCookie(/cuid$/i);
  return v ? +v : null;
};
export const setCurrentUserId = (userID: number) => setCookie("cuid", userID.toString(), 365);

export type CartCookieItem = {
  id: string;
  quantity: number;
};
export type CartCookie = {
  items: CartCookieItem[] | null;
};
export const getCart = (portalId: string): CartCookie | null => {
  const cookie = getCookie(`Cart_${portalId}`);
  if (!cookie) return null;
  try {
    return JSON.parse(atob(decodeURIComponent(cookie)));
  } catch {
    return null;
  }
};
